export default __webpack_public_path__ + "static/media/information.ba9ad0eb.svg";